import { autocompletePhoneCountryInput, createVPhoneInput, VPhoneCountryFlagSvg } from 'v-phone-input'
import 'flag-icons/css/flag-icons.min.css'

export const vPhoneInput = createVPhoneInput({
  ...autocompletePhoneCountryInput,
  countryDisplayComponent: VPhoneCountryFlagSvg,
})
